// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__10N-k","ScrollX":"Scroll_ScrollX__1P1SX","ScrollY":"Scroll_ScrollY__1L2_b"};